/* eslint-disable */
import PropTypes from 'prop-types';
import { I18N_DIRECTION_LEFT_TO_RIGHT, I18N_DIRECTION_RIGHT_TO_LEFT, I18N_LANGS } from '../../Constants/I18n/I18n.constants';
/**
 * The possible `lang` directions
 */
const direction = PropTypes.oneOf([I18N_DIRECTION_LEFT_TO_RIGHT, I18N_DIRECTION_RIGHT_TO_LEFT]);

/**
 * A `lang`
 */
const lang = PropTypes.oneOf(I18N_LANGS);

/**
 * A `locale`
 */
const locale = PropTypes.shape({
  direction: PropTypes.oneOf([I18N_DIRECTION_LEFT_TO_RIGHT, I18N_DIRECTION_RIGHT_TO_LEFT]).isRequired,
  label: PropTypes.string.isRequired,
  lang: PropTypes.oneOf(I18N_LANGS).isRequired,
  shortLabel: PropTypes.string.isRequired,
});

/**
 * The `locale`s
 */
const locales = PropTypes.arrayOf(locale);

const I18nEntityPropTypes = {
  /**
   * The possible `lang` directions
   */
  direction,

  /**
   * A `lang`
   */
  lang,

  /**
   * A `locale`
   */
  locale,

  /**
   * The `locale`s
   */
  locales,
};

export default I18nEntityPropTypes;
